import { motion, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';

/** Strong ease-out — responsive UI entrances (emil-design-eng) */
export const EASE_OUT = [0.23, 1, 0.32, 1] as const;

/** Press feedback for auth / learn CTAs */
export const PRESSABLE_CLASS =
  'transition-[transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.97]';

/**
 * Rare first-visit shell for login/register.
 * Purpose: prevent a jarring hard-cut; stay under 300ms; never scale(0).
 */
export function AuthPageShell({
  children,
  logo,
}: {
  children: ReactNode;
  logo?: ReactNode;
}) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-white px-5 py-8 dark:bg-gray-950">
      <motion.div
        className="w-full max-w-sm"
        initial={
          shouldReduceMotion
            ? false
            : { opacity: 0, transform: 'translateY(8px) scale(0.98)' }
        }
        animate={{ opacity: 1, transform: 'translateY(0px) scale(1)' }}
        transition={{ duration: 0.22, ease: EASE_OUT }}
      >
        {logo ? <div className="mb-8">{logo}</div> : null}
        {children}
      </motion.div>
    </div>
  );
}
